import { render, staticRenderFns } from "./LdmInfo.vue?vue&type=template&id=2855edf2"
import script from "./LdmInfo.vue?vue&type=script&lang=js"
export * from "./LdmInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports